import * as React from "react";
import {Linear, TweenMax} from "gsap";

class SvgSuccessStars extends React.Component {

  componentDidMount() {
      this.animateStars();
  }

  animateStars = () => {
      const star = document.getElementById('success-spaceman-new_svg__Spaceman_star');
      const starContainer = document.getElementById('success-spaceman-new_svg__Spaceman_star_container');

      // Stars
      for (let i = 0; i < 200; i++) {
          const sc = star.cloneNode(true);
          const height = window.outerHeight;
          const x = Math.random() * 100;
          starContainer.appendChild(sc);

          // console.log(Math.random() * 100);
          const calc = ((Math.random() * 100) + 1) / 2;
          TweenMax.fromTo(sc, calc, {
              x,
              y: -(Math.random() * 1000),
              scale: 1 * (Math.random(5) * 1)
          }, {
              x,
              y: height + 200,
              repeat: -1,
              repeatDelay: 0,
              ease: Linear.easeNone
        })
      }
      star.remove();
  }

  render() {
    const { props } = this;
    return (
        <svg viewBox="0 0 100 100" {...props}>
          <g width="100%" height="100%" id="success-spaceman-new_svg__Spaceman_star_container">
            <path
                id="success-spaceman-new_svg__Spaceman_star"
                opacity={0.7}
                fill="#ECB447"
                d="M1.2 0l.4.8.8.1-.6.6.1.8-.7-.4-.7.4.1-.8L0 .9.8.8z"
            />
          </g>
        </svg>
    )
  }
}

export default SvgSuccessStars;
